import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { InformationCardComponent } from '../../../components/information-card/information-card.component';
import { Category } from '../../../services/http/categories/categories.interface';
import { VehiclesService } from '../../../services/http/vehicles/vehicles.service';
import { PlateResponse } from '../../../services/http/vehicles/vehicles.interface';
import { FormsModule } from '@angular/forms';
import { Label } from '../../../services/http/labels/labels.interface';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { AlertService } from '../../../services/alert/alert.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { LanguageUtils } from '../../../services/utils/language.utils';

@Component({
  selector: 'app-vehicle-check',
  standalone: true,
  imports: [CommonModule, RouterLink, InformationCardComponent, FormsModule, ImageSectionHeadComponent],
  templateUrl: './vehicle-check.component.html',
  styleUrl: './vehicle-check.component.scss'
})
export class VehicleCheckComponent {
  title = $localize`:@@VehiclesCheck.title:Vehículos afectados`;
  description = "";
  image = "assets/images/Vehiculos.jpg";
  texto_descripcion = "Les etiquetes ambientals ajuden a identificar els vehicles més respectuosos amb el medi ambient. A continuació trobaràs els diferents models.";

  categories: Category[] = [];
  plate = "";
  plateResponse: PlateResponse | undefined;
  labels: Label[] = [];

  constructor(
    private readonly vehiclesService: VehiclesService,
    private readonly wordpressService: WordpressService,
    private readonly alertService: AlertService,
    private readonly loaderService: LoaderService,
    private readonly router: Router
  ) {
    this.wordpressService.getPosts({section: WpSectionCode.ambientalTag, client: WpClientCode.genCat}).subscribe((response) => {
      this.labels = response?.sort((a, b) => a.acf.orden_label - b.acf.orden_label)
        .map((label) => {
          return {
            code: label.acf.titulo,
            description: label.content.rendered,
            image: label.acf.icono
          } as Label;
        
        }) || [];
    });

    this.wordpressService.getPosts({section: WpSectionCode.vehicleCategory, client: WpClientCode.genCat}).subscribe((response) => {
      this.categories = response?.sort((a, b) => a.id - b.id)
        .map((label) => {
          return {
            code: label.title.rendered,
            description: label.content.rendered
          } as Category;
        
        }) || [];
    });

    if (LanguageUtils.getLanguage() == 'es-ES') {
      this.texto_descripcion = "Las etiquetas ambientales ayudan a identificar a los vehículos más respetuosos con el medio ambiente. A continuación encontrarás los distintos modelos.";
    }

    
  }

  checkPlate() {
    if (!this.plate) {
      this.alertService.setAlert({
        message: $localize`:@@Vehicles.Check.Empty:Debe introducir una matrícula`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    this.loaderService.hide();
    this.vehiclesService.checkPlate(this.plate).subscribe({
      next:  response => {
        this.plateResponse = response;
        this.loaderService.hide();
      }
    });
  }

  resetPlate() {
    this.plate = "";
    this.plateResponse = undefined;
  }

  getLabel(key: string): string {
    const label = this.labels.find(label => label.code === key);
    if (label) {
      return label.image?.data || key;
    } else {
      return key;
    }
  }

  goToLabels() {
    this.router.navigate(['/zbe/tags']);
  }

  onInputChange(event: Event): void {
    this.plate = this.plate.toUpperCase();
  }

  goLogin() {
    this.router.navigate(['/login']);
  }
}
